export default "__VITE_ASSET__b2c44230__"